(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gdc-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.gdc-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.gdc-faq__item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdc-product-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.querySelector('.gdc-pd');
  if (!section) return;
  var form = document.getElementById('gdc-product-form');
  if (!form) return;
  var variantsEl = document.getElementById('gdc-variants');
  if (!variantsEl) return;

  var variants = JSON.parse(variantsEl.textContent);
  var variantInput = form.querySelector('[name="id"]');
  var priceEl = document.getElementById('gdc-price');
  var compareEl = document.getElementById('gdc-compare-price');
  var donationEl = document.getElementById('gdc-donation');
  var stickyNoteEl = document.getElementById('gdc-sticky-note');
  var atcBtn = document.getElementById('gdc-atc-btn');
  var mainImg = document.getElementById('gdc-pd-img');
  var moneyFormat = section.dataset.moneyFormat || '${{amount}}';
  var donationPct = parseFloat(section.dataset.donationPct) || 0;
  var donationSuffix = donationEl ? (donationEl.dataset.suffix || '') : '';
  var stickySuffix = stickyNoteEl ? (stickyNoteEl.dataset.suffix || '') : '';

  var addText = atcBtn ? (atcBtn.dataset.addText || 'Add to Cart') : '';
  var soldText = atcBtn ? (atcBtn.dataset.soldText || 'Sold Out') : '';
  var addingText = atcBtn ? (atcBtn.dataset.addingText || 'Adding...') : '';

  var selected = [];
  section.querySelectorAll('.gdc-pd-opt-btn.is-active').forEach(function (btn) {
    selected[parseInt(btn.dataset.optionIndex, 10)] = btn.dataset.value;
  });

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var rounded = String(Math.round(cents / 100));
    return moneyFormat
      .replace('{{amount}}', amount.replace(/\.00$/, ''))
      .replace('{{amount_with_comma_separator}}', amount)
      .replace('{{amount_no_decimals}}', rounded)
      .replace('{{ amount }}', amount.replace(/\.00$/, ''));
  }

  function updateDonation(price) {
    if (!donationPct) return;
    var don = formatMoney(Math.round(price * donationPct / 100));
    if (donationEl) donationEl.textContent = don + (donationSuffix ? ' ' + donationSuffix : '');
    if (stickyNoteEl) stickyNoteEl.textContent = don + (stickySuffix ? ' ' + stickySuffix : '');
  }

  function findVariant() {
    return variants.find(function (v) {
      if (selected[0] !== undefined && v.option1 !== selected[0]) return false;
      if (selected[1] !== undefined && v.option2 !== selected[1]) return false;
      if (selected[2] !== undefined && v.option3 !== selected[2]) return false;
      return true;
    });
  }

  function swapImage(src) {
    if (!mainImg || !src) return;
    mainImg.classList.add('is-loading');
    var tmp = new Image();
    tmp.onload = function () {
      mainImg.src = src;
      mainImg.classList.remove('is-loading');
    };
    tmp.onerror = function () { mainImg.classList.remove('is-loading'); };
    tmp.src = src;
  }

  function updateVariant() {
    var v = findVariant();
    if (!v) return;

    if (variantInput) variantInput.value = v.id;
    if (priceEl) priceEl.textContent = formatMoney(v.price);
    updateDonation(v.price);

    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.setAttribute('hidden', '');
      }
    }

    if (atcBtn) {
      if (v.available) {
        atcBtn.disabled = false;
        atcBtn.classList.remove('is-disabled');
        atcBtn.textContent = addText;
      } else {
        atcBtn.disabled = true;
        atcBtn.classList.add('is-disabled');
        atcBtn.textContent = soldText;
      }
    }

    if (v.featured_image && mainImg) {
      var src = v.featured_image.src;
      swapImage(src);
      section.querySelectorAll('.gdc-pd-thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.src === src);
      });
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }

  section.querySelectorAll('.gdc-pd-opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(this.dataset.optionIndex, 10);
      selected[idx] = this.dataset.value;
      section.querySelectorAll('.gdc-pd-opt-btn[data-option-index="' + idx + '"]').forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.value === selected[idx]);
      });
      var valDisplay = section.querySelector('#gdc-opt-val-' + idx);
      if (valDisplay) valDisplay.textContent = selected[idx];
      updateVariant();
    });
  });

  var qtyInput = form.querySelector('[name="quantity"]');
  var decBtn = document.getElementById('gdc-qty-dec');
  var incBtn = document.getElementById('gdc-qty-inc');
  if (decBtn && qtyInput) {
    decBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
  }
  if (incBtn && qtyInput) {
    incBtn.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  section.querySelectorAll('.gdc-pd-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      swapImage(this.dataset.src);
      section.querySelectorAll('.gdc-pd-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  if (form && atcBtn) {
    form.addEventListener('submit', function () {
      if (!atcBtn.disabled) {
        atcBtn.classList.add('is-loading');
        atcBtn.textContent = addingText;
      }
    });
  }

  // Sticky bar: reveal once the main section scrolls out of view; button submits the form.
  var sticky = document.getElementById('gdc-pd-sticky');
  if (sticky) {
    var stickyBtn = document.getElementById('gdc-sticky-btn');
    if (stickyBtn && atcBtn) {
      stickyBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(atcBtn); }
        else { atcBtn.click(); }
      });
    }
    var onScroll = function () {
      var visible = section.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
